import Grid from "@mui/material/Grid";
import SoftBox from "components/SoftBox";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import MiniStatisticsCard from "examples/Cards/StatisticsCards/MiniStatisticsCard";
import ReportsBarChart from "examples/Charts/PieChart";
import GradientLineChart from "examples/Charts/BarCharts/VerticalBarChart copy";
import SoftPagination from "components/SoftPagination";
import { useEffect, useState } from "react";
import { baseURL } from "utils/api";
import { useDispatch, useSelector } from "react-redux";
import { Card, Pagination, Stack } from "@mui/material";
import TableData from "../coupon/data/tabledata";
import Table from "examples/Tables/Table";
import Loading from "components/ApnaLoading";
import NotFound from "components/notFound";
import SoftTypography from "components/SoftTypography";
import SoftInput from "components/SoftInput";
import SoftButton from "components/SoftButton";
import { Download } from "@mui/icons-material";
import moment from "moment";
import toast from "react-hot-toast";
import { getLocationData } from 'api/commonSlice';

function Dashboard() {

const dispatch = useDispatch();
const userTheme = useSelector((state) => state.commonSlice.theme);
  const id = localStorage.getItem('id');
  const [dashboardData, setDashboardData] = useState({});
  const [pieChartSelectFilter, setPieChartSelectFilter] = useState('');
  const [pieChartOptions, setPieChartOptions] = useState([]);
  const [selectedFilter, setSelectedFilter] = useState('yearly');
  const filterLocation = useSelector((state) => state.searchSlice?.filterLocation);
  const [loading, setLoading] = useState(false);
  const [searchData, setSearchData] = useState('');
  const [data, setData] = useState([])
  const [page, setPage] = useState(1);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const { columns, rows } = data;
  const [totalPage, setTotalPage] = useState(1);
  const [offerType, setOfferType] = useState(null);
  const [gradientLineChartData, setGradientLineChartData] = useState({
    labels: [],
    datasets: [
      {
        label: "Coupons",
        color: "info",
        data: [],
      },
    ],
    text: ""
  });

  useEffect(() => {
    dispatch(getLocationData());  
  }, []); 
  


  useEffect(() => {
    gradientLineChartData.labels &&
      setPieChartOptions(gradientLineChartData.labels.map((item) => {
        return { _id: item, name: item }
      }));
    if (selectedFilter === 'yearly') {
      if(gradientLineChartData.labels.length > 0){
        setPieChartSelectFilter(gradientLineChartData.labels[0]);
      }
    } else {
      if(gradientLineChartData.labels.length > 0){
        setPieChartSelectFilter(gradientLineChartData.labels[0]);
      }
    }

  }, [gradientLineChartData]);

  const [pieChartData, setPieChartData] = useState({
    labels: ["BOGO", "Discount"],
    datasets: {
      data: [0, 0],
      backgroundColors: ["info", "primary", "secondary"],
    }
  });

  const filterOptions = [
    { _id: "yearly", name: "Yearly" },
    { _id: "monthly", name: "Monthly" },
    { _id: "weekly", name: "Weekly" },
    { _id: "daily", name: "Daily" },
  ];

  const handleFilterChange = (e) => {
    setSelectedFilter(e.target.value);
  };

  const handleFilterChangePieChart = (e) => {
    setPieChartSelectFilter(e);
  };

  const fetchDashboardData = (ev) => {
    fetch(`${baseURL}/dashBoardData/${id}/${ev}`)
      .then(res => res.json())
      .then(data => {
        if (data.status === 200) {
          setDashboardData(data.data)
        }
      }).catch(err => {
        toast.error(err.message || 'Something went wrong');
      });
  }

  const fetchBarData = (filter, ev) => {
    fetch(`${baseURL}/dashBoardBarChartData/${id}/${filter}/${ev}`)
      .then(res => res.json())
      .then(data => {
        if (data.status === 200) {
          const labels = data?.data?.period.map((item) => item?.value);
          const datasets = data?.data?.record.map((item) => item?.value);
          setGradientLineChartData({
            labels: labels,
            datasets: [
              {
                label: "Coupons",
                color: "info",
                data: datasets,
              },
            ],
            text: data?.data?.text
          });
        }
      }).catch(err => {
        toast.error(err.message || 'Something went wrong');
      });
  }


  const fetchPieChartData = (filter, secondFilter, ev) => {
    if (secondFilter) {
      fetch(`${baseURL}/pieChartData/${id}/${ev}/${secondFilter}/${filter}`)
        .then(res => res.json())
        .then(data => {
          if (data.status === 200) {
            setPieChartData({
              labels: ["BOGO", "Discount"],
              datasets: {
                data: data?.data,
                backgroundColors: ["info", "primary", "secondary"],
              }
            });
          }
        }).catch(err => {
          toast.error(err.message || 'Something went wrong');
        });
    }
  }


  useEffect(() => {
    fetchDashboardData(filterLocation)
    fetchBarData(selectedFilter, filterLocation);
    fetchPieChartData(selectedFilter, pieChartSelectFilter, filterLocation);
    if (filterLocation) {
      fetchData(1, offerType, startDate, endDate, searchData, filterLocation);
    }
  }, [filterLocation, selectedFilter]);

  useEffect(() => {
    if (pieChartSelectFilter) {
      fetchPieChartData(selectedFilter, pieChartSelectFilter, filterLocation);

      const currentDate = new Date();
      let newStartDate = null;
      let newEndDate = currentDate;

      if (selectedFilter === 'yearly') {
        newStartDate = new Date(pieChartSelectFilter, 0, 1);
        newEndDate = new Date(pieChartSelectFilter, 11, 31);
      } else if (selectedFilter === 'monthly') {
        const monthIndex = gradientLineChartData.labels.indexOf(pieChartSelectFilter);
        newStartDate = new Date(currentDate.getFullYear(), monthIndex, 1);
        newEndDate = new Date(currentDate.getFullYear(), monthIndex + 1, 0);
      } else if (selectedFilter === 'weekly') {
        const weekIndex = gradientLineChartData.labels.indexOf(pieChartSelectFilter);
        newStartDate = new Date(currentDate.setDate(currentDate.getDate() - currentDate.getDay() + (weekIndex * 7)));
        newEndDate = new Date(newStartDate);
        newEndDate.setDate(newEndDate.getDate() + 6);
      } else if (selectedFilter === 'daily') {
        const dayIndex = gradientLineChartData.labels.indexOf(pieChartSelectFilter);
        newStartDate = new Date(currentDate.setDate(currentDate.getDate() - currentDate.getDay() + dayIndex));
        newEndDate = new Date(newStartDate);

      }

      fetchData(1, offerType, newStartDate.toISOString(), newEndDate.toISOString(), searchData, filterLocation);
      setStartDate(newStartDate);
      setEndDate(newEndDate);
    }
  }, [pieChartSelectFilter]);



  const handlePageChange = (page) => {
    setPage(page);
    fetchData(page, offerType, startDate, endDate, searchData, filterLocation);
  }

  const fetchData = (ev, offerType, startDate, endDate, searchData, filterLocation) => {
    setLoading(true);
    fetch(`${baseURL}/redeemed-coupon-list/${id}?column=6&start=0&length=10&sort=createdAt${searchData != '' ? `&searchdata=${searchData}` : ''}&page=${ev}${offerType != null ? `&offerType=${offerType}` : ''}${startDate != null ? `&startDate=${startDate}` : ''}${endDate != null ? `&endDate=${endDate}` : ''}${filterLocation != 'default' ? `&locationId=${filterLocation}` : ''}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application-json',
        'Authorization': `Bearer ${localStorage.getItem('token')}`
      }
    }).then(res => res.json())
      .then(data => {
        if (data.status === 200) {
          setData(TableData({
            data: data?.data,
          }));
          setTotalPage(data?.totalPages)
        };
        setLoading(false);
      }).catch(err => {
        toast.error(err.message || 'Something went wrong');
      });
  };

  const handelOnClickPieChart = (ev) => {
    if (ev === 0) {
      fetchData(page , "Buy One Get One", startDate, endDate, searchData, filterLocation);
      setOfferType("Buy One Get One"); 
    } else {
      fetchData(page , "Percentage OFF", startDate, endDate, searchData, filterLocation);
      setOfferType("Percentage OFF");
    }
  }

  const handleOnClickBarChart = (ev) => {
    const findFilter = gradientLineChartData.labels[ev];
    setPieChartSelectFilter(findFilter);
  }


  const handleSubmit = () => {
    fetchData(1, offerType, new Date(startDate).toISOString(), new Date(endDate).toISOString(), searchData, filterLocation);
  }


  const exportFile = async (ev, offerType, startDate, endDate, searchData, main) => {
    try {
      setLoading(true);

      const url = `${baseURL}/redeemed-coupon-list/${id}/${main}?column=0&start=0&length=10&dir=asc&page=${ev}`
        + (offerType ? `&offerType=${offerType}` : '')
        + (startDate ? `&startDate=${startDate}` : '')
        + (endDate ? `&endDate=${endDate}` : '')
        + (searchData ? `&searchdata=${searchData}` : '')

      const response = await fetch(url, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json', // Fixed typo
          'Authorization': `Bearer ${localStorage.getItem('token')}`
        }
      });

      if (!response.ok) {
        console.error(`Failed to fetch: ${response.statusText}`);
        throw new Error('Failed to fetch file data');
      }

      const data = await response.json();

      if (data.status === 200 && data?.download) {
        if (main === 'pdf') {
          const blob = new Blob([new Uint8Array(data?.download?.data)], { type: 'application/pdf' });
          const link = document.createElement('a');
          link.href = window.URL.createObjectURL(blob);
          link.setAttribute('download', 'file.pdf');
          document.body.appendChild(link);
          link.click();
          link.remove();
        } else {
          const blob = new Blob([new Uint8Array(data?.download?.data)], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
          const link = document.createElement('a');
          link.href = window.URL.createObjectURL(blob);
          link.setAttribute('download', 'file.xlsx');
          document.body.appendChild(link);
          link.click();
          link.remove();
        }
      } else {
        console.error('Invalid data or download link');
        throw new Error('Invalid data or download link');
      }
    } catch (err) {
      console.error('Error exporting file:', err);
    } finally {
      setLoading(false);
    }
  };

  const onSearchChange = (e) => {
    fetchData(1, offerType, startDate, endDate, e.target.value, filterLocation);
    setSearchData(e.target.value);
  };



  return (
    <DashboardLayout>
      <DashboardNavbar />
      <SoftBox py={3}>
        <SoftBox mb={3}>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={6} xl={2.5}>
              <MiniStatisticsCard
                title={{ text: "Total Customers" }}
                count={dashboardData?.total_users || 0}
                icon={{ color: "info", component: "people" }}
              />
            </Grid>
            <Grid item xs={12} sm={6} xl={2.8}>
              <MiniStatisticsCard
                title={{ text: "Returned Customers" }}
                count={dashboardData?.returnedCustomer || 0}
                percentage={{
                  color: parseInt(dashboardData?.percentageOfReturnedCustomer) > 0 ? "success" : "error",
                  text: ` ${parseInt(dashboardData?.percentageOfReturnedCustomer) > 0 ? '+' : ''}${dashboardData?.percentageOfReturnedCustomer}`
                }}
                icon={{ color: "info", component: "hail" }}
              />
            </Grid>
            
            <Grid item xs={12} sm={6} xl={2.2}>
              <MiniStatisticsCard
                title={{ text: "Total Reviews" }}
                count={dashboardData?.totalReviewsCount || 0}
                icon={{ color: "info", component: "tablet_mac" }}
              />
            </Grid>
            <Grid item xs={12} sm={6} xl={2}>
              <MiniStatisticsCard
                title={{ text: "Total Views" }}
                count={dashboardData?.total_visit || 0}
                icon={{
                  color: "info",
                  component: "wysiwyg",
                }}
              />
            </Grid>
          
            <Grid item xs={12} sm={6} xl={2.5}>
              <MiniStatisticsCard
                title={{ text: "Unique Visitors" }}
                count={dashboardData?.distinct_record || 0}
                icon={{
                  color: "info",
                  component: "wysiwyg",
                }}
              />
            </Grid>
          </Grid>
        </SoftBox>

        <SoftBox mb={3}>
          <Grid container spacing={3}>

            <Grid item xs={12} lg={6}>
              <GradientLineChart
                handleOnClickBarChart={handleOnClickBarChart}
                option={filterOptions}
                handleFilterChange={handleFilterChange}
                selectedFilter={selectedFilter}
                title="Coupons Used"
                description={
                  <SoftTypography variant='caption' display="flex" alignItems="center">

                    {gradientLineChartData?.text}
                  </SoftTypography>
                }
                height="20.25rem"
                chart={gradientLineChartData}
              />
            </Grid>
            <Grid item xs={12} lg={6}>
              <ReportsBarChart
                handleFilterChangePieChart={handleFilterChangePieChart}
                option={pieChartOptions}
                value={pieChartSelectFilter}
                height="21.25rem"
                title="Coupons Redeemed"
                handelOnClickPieChart={handelOnClickPieChart}
                description={
                  <>
                    <strong></strong>
                  </>
                }
                chart={pieChartData}
              />
            </Grid>
          </Grid>
        </SoftBox>
        <SoftBox mb={3}>
          <Card className="glassmorphism-card">
            <SoftBox
              sx={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                m: 2
              }}
            >

              <SoftBox width="30%" >
                <SoftInput
                  onChange={onSearchChange}
                  placeholder="Search here..."
                 
                  icon={{ component: "search", direction: "left" }}
                />
              </SoftBox>

              <SoftBox
                width="65%"
                ml={2}
              >

                {/* <SoftTypography variant="h6" fontWeight="medium" >
                  Select Date Range
                </SoftTypography> */}
                <SoftBox sx={{ display: 'flex', gap: 2,}}>

                  <SoftInput label="Start Date" type="date" value={startDate}
                    onChange={(e) => {
                      setStartDate(e.target.value)
                    }}

                  />

                  <SoftInput label="End Date" type="date" value={endDate}
                    onChange={(e) => {
                      setEndDate(e.target.value)
                    }}

                  />

                  <SoftButton
                  fullWidth
                    variant="gradient"
                    color="info"
                    sx={{ color: 'white', marginRight: 2 }}
                    onClick={handleSubmit}
                  >
                    Submit
                  </SoftButton>
                </SoftBox>

              </SoftBox>

              <SoftBox
                width="40%" display="flex" gap={2} mt={2} alignItems='center' justifyContent='end' >
                <SoftButton variant="contained" 
                // color="black"
                style={{ backgroundColor: userTheme === 'dark' ? '#1e1e1e' : 'gainsboro', color: userTheme === 'dark' ? '#ffffff' : '#000000' }}
                  disabled={rows?.length === 0}
                  onClick={() => exportFile(page, offerType, startDate, endDate, searchData, 'excel')}
                >
                  <img
                    src={require("../../assets/images/xls.png")}
                    alt="excel"
                    style={{ width: "30px", height: "30px", marginRight: "5px" }}
                  />
                  <SoftBox ml={1} mt={1}
                        sx={{color: userTheme === 'dark' ? '#ffffff' : '#000000'}}
                  >
                    <Download />
                  </SoftBox>
                </SoftButton>
                <SoftButton variant="contained"           
                      style={{ backgroundColor: userTheme === 'dark' ? '#1e1e1e' : 'gainsboro', color: userTheme === 'dark' ? '#ffffff' : '#000000' }}
                  disabled={rows?.length === 0}
                  onClick={() => exportFile(page, offerType, startDate, endDate, searchData, 'pdf')}
                >
                  <img
                    src={require("../../assets/images/pdff.png")}
                    alt="excel"
                    style={{ width: "30px", height: "30px", marginRight: "5px" }}
                  />
                  
                  <SoftBox ml={1} mt={1}
                  sx={{color: userTheme === 'dark' ? '#ffffff' : '#000000'}}
                  >
                    <Download />
                  </SoftBox>
                </SoftButton>
              </SoftBox>
            </SoftBox>
            <SoftBox
              sx={{
                "& .MuiTableRow-root:not(:last-child)": {
                  "& td": {
                    borderBottom: ({ borders: { borderWidth, borderColor } }) =>
                      `${borderWidth[1]} solid ${borderColor}`,
                  },
                },
              }}
            >
              {
                loading ? <Loading /> : rows?.length > 0 ? <Table columns={columns} rows={rows} /> : <NotFound />
              }

            </SoftBox>
            {
              rows && rows?.length > 0 &&
              <>
                <Stack spacing={5} m={5} sx={{ display: "flex", alignItems: 'center', justifyContent: "center" }}>
                  <Pagination
                    onChange={(event, page) => handlePageChange(page)}
                    count={totalPage}
                    variant="outlined"
                    sx={{
                      '& .MuiPaginationItem-root': {
                        color: 'gray',
                        borderColor: "gray"
                      },
                      '& .Mui-selected': {
                        color: '#ffffff',
                        borderColor: "#ffffff",
                      },
                    }}
                    shape="rounded"
                  />
                </Stack>

              </>
            }
          </Card>
        </SoftBox>
        <SoftPagination />
      </SoftBox>
      {/* <Footer /> */}
    </DashboardLayout>
  );
}

export default Dashboard;
